import { createRoutine } from '@hozana/routines/functions'

import type { TSendContactFormMutationPayload } from 'modules/home/queries'

export const contactFormSubmit = createRoutine<'CONTACT_FORM_SUBMIT', TSendContactFormMutationPayload>(
  'CONTACT_FORM_SUBMIT',
)
